import { CardSvg } from '@/play/cardSvg'

/**
 * Home card art for Vanishing trail: a pink stroke over green hills, and a silver comet trail riding
 * its newest end, thinning out behind the tip (no text).
 */
export function VanishingTrailCardArt() {
  return (
    <CardSvg bg="#f3f6f8">
      {(id) => (
        <>
          <defs>
            <radialGradient id={id('chrome')} cx="0.35" cy="0.3" r="0.9">
              <stop offset="0" stopColor="#ffffff" />
              <stop offset="0.45" stopColor="#dfe5ea" />
              <stop offset="0.8" stopColor="#7d8893" />
              <stop offset="1" stopColor="#c9d1d8" />
            </radialGradient>
          </defs>
          {/* Hills. */}
          <path d="M0 200 L 0 150 C 40 110, 90 100, 130 135 C 160 160, 190 120, 230 112 C 270 104, 300 130, 320 140 L 320 200 Z" fill="#cfdcbd" />
          <path d="M0 200 L 0 172 C 60 160, 120 175, 180 168 C 240 160, 280 172, 320 166 L 320 200 Z" fill="#c3d4b0" />
          {/* The ink that stays. */}
          <path d="M40 150 C 70 118, 100 116, 125 138 C 150 160, 180 140, 205 124 S 238 112, 250 116" fill="none" stroke="#ff5fa2" strokeWidth="13" strokeLinecap="round" />
          {/* The trail: thick at the tip, thinning back along the stroke. */}
          <circle cx="250" cy="116" r="17" fill={`url(#${id('chrome')})`} />
          <circle cx="228" cy="118" r="13" fill={`url(#${id('chrome')})`} />
          <circle cx="208" cy="123" r="10" fill={`url(#${id('chrome')})`} />
          <circle cx="190" cy="131" r="7" fill={`url(#${id('chrome')})`} />
          <circle cx="174" cy="139" r="4.5" fill={`url(#${id('chrome')})`} />
          <circle cx="160" cy="145" r="2.5" fill={`url(#${id('chrome')})`} />
        </>
      )}
    </CardSvg>
  )
}
